
<div class="skeleton-loader">
  <div *ngIf="show_avatar" class="skeleton skeleton-avatar"></div>
  <div *ngIf="show_line" class="skeleton skeleton-line"></div>
  <div *ngIf="show_line2" class="skeleton skeleton-line short"></div>
</div>